import api from ".";

export const financeCrud = (id, data, method, callBack) => {
    const path = id ? `/financial-entries/${id}/` : '/financial-entries/';

    const payload = { ...data };
    if (method !== 'get') {
        delete payload.id;
    }

    const config = method === 'get' && !id ? {} : payload;

    api[method](path, config)
        .then((response) => {
            callBack(response?.data);
        })
        .catch((error) => {
            callBack(error?.response);
        });
};

export const downloadToCsv = (payload, callBack) => {
    api.post(`/financial-entries/download/`, payload, {
        responseType: 'blob',
    })
        .then((response) => {
            const blob = new Blob([response.data], { type: 'application/zip' });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;

            link.setAttribute('download', `financial_entries.zip`);

            document.body.appendChild(link);
            link.click();

            link.remove();
            window.URL.revokeObjectURL(url);

            callBack(response.data);
        })
        .catch((error) => {
            callBack(error?.response);
        });
};

export const customDownloadToCsv = (sheetId, payload, callBack) => {
    api.post(`/financial-entries/${sheetId}/download/custom/`, payload, {
        responseType: 'blob',
    })
        .then((response) => {
            const blob = new Blob([response.data], { type: 'application/zip' });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;

            link.setAttribute('download', `filtered_financial_entries.zip`);

            document.body.appendChild(link);
            link.click();

            link.remove();
            window.URL.revokeObjectURL(url);

            callBack(response);
        })
        .catch(async (error) => {
            if (error.response && error.response.data instanceof Blob) {
                const errorData = await error.response.data.text();
                try {
                    const errorJson = JSON.parse(errorData);
                    callBack({ ...error.response, data: errorJson });
                } catch (e) {
                    callBack(error.response);
                }
            } else {
                callBack(error.response);
            }
        });
};





